const initialState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: undefined,
  endDate: undefined,
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
}
const resetState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: undefined,
  endDate: undefined,
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const qualityReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETQUALITYWORKORDERTYPE':
      return {
        ...state,
        workOrderType: action.payload,
      };
    case 'SETQUALITYWORKORDERSTATUS':
      return {
        ...state,
        workOrderStatus: action.payload,
      };
    case 'SETQUALITYSTARTDATE':
      return {
        ...state,
        startDate: action.payload,
      };
    case 'SETQUALITYENDDATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SETQUALITYSEARCHDATA':
      return {
        ...state,
        searchData: action.payload,
      };
    case 'SETQUALITYSEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETQUALITYSEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETQUALITYPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETQUALITYTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETQUALITYISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETQUALITYRESET':
      return {
        ...state,
        ...resetState,
      };
    default:
      return state;
  };
};

export default qualityReducer;